var map = {
	"./afb-color.svg": 1464,
	"./alb-color.svg": 1465,
	"./all.svg": 1466,
	"./amb-color.svg": 1467,
	"./arg.svg": 1468,
	"./aus.svg": 1469,
	"./bank-icon.svg": 1470,
	"./bankdemo-color.svg": 1471,
	"./bel.svg": 1472,
	"./bimb-color.svg": 1473,
	"./bkr-color.svg": 1474,
	"./bpay-color.svg": 1475,
	"./bra.svg": 1476,
	"./bsn-color.svg": 1477,
	"./can.svg": 1478,
	"./checked-white.png": 1479,
	"./cimb-color.svg": 1480,
	"./cimb-icon.svg": 1481,
	"./citi-color.svg": 1482,
	"./cmr.svg": 1483,
	"./crc.svg": 1484,
	"./cro.svg": 1485,
	"./den.svg": 1486,
	"./ecu.svg": 1487,
	"./eng.svg": 1488,
	"./esp.svg": 1489,
	"./fav-gray.png": 1490,
	"./fav-icon-active.png": 1491,
	"./fav-icon.png": 1492,
	"./fav-red.png": 1493,
	"./fra.svg": 1494,
	"./game-icon.svg": 1495,
	"./games-active-m.svg": 1496,
	"./games-m.svg": 1497,
	"./ger.svg": 1498,
	"./gha.svg": 1499,
	"./gxbank-color.svg": 1500,
	"./hlb-color.svg": 1501,
	"./hlb-icon.svg": 1502,
	"./hsbc-color.svg": 1503,
	"./irn.svg": 1504,
	"./jpn.svg": 1505,
	"./kor.svg": 1506,
	"./ksa.svg": 1507,
	"./kwh-color.svg": 1508,
	"./latest-icon-active.png": 1509,
	"./latest-icon.png": 1510,
	"./lc-active-m.svg": 1511,
	"./lc-icon.svg": 1512,
	"./lc-m.svg": 1513,
	"./lottery-active-m.svg": 1514,
	"./lottery-icon.svg": 1515,
	"./lottery-m.svg": 1516,
	"./love.svg": 1517,
	"./mar.svg": 1518,
	"./mbb-color.svg": 1519,
	"./mex.svg": 1520,
	"./ned.svg": 1521,
	"./ocbc-color.svg": 1522,
	"./ocbc-icon.svg": 1523,
	"./p2p-active-m.svg": 1524,
	"./p2p-icon.svg": 1525,
	"./p2p-m.svg": 1526,
	"./pbb-color.svg": 1527,
	"./pol.svg": 1528,
	"./por.svg": 1529,
	"./price-high.svg": 1530,
	"./price-low.svg": 1531,
	"./qat.svg": 1532,
	"./rhb-color.svg": 1533,
	"./rhb-icon.svg": 1534,
	"./scb-color.svg": 1535,
	"./sen.svg": 1536,
	"./slot-active-m.svg": 1537,
	"./slot-icon.svg": 1538,
	"./slot-m.svg": 1539,
	"./sport-active-m.svg": 1540,
	"./sport-m.svg": 1541,
	"./sports-icon.svg": 1542,
	"./square-icon.svg": 1543,
	"./srb.svg": 1544,
	"./star.svg": 1545,
	"./sui.svg": 1546,
	"./tng-color.svg": 1547,
	"./trx-icon.svg": 1548,
	"./trx.svg": 1549,
	"./tun.svg": 1550,
	"./uefa-icon.svg": 1551,
	"./uob-color.svg": 1552,
	"./uru.svg": 1553,
	"./usa.svg": 1554,
	"./usdc.svg": 1555,
	"./usdt.svg": 1556,
	"./ustd-icon.svg": 1557,
	"./wal.svg": 1558,
	"./x33-logo-b.svg": 1559,
	"./x33-square-icon.svg": 1560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;